import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogRoles from './EditCatalogRoles'
import ListCatalogRoles from './ListCatalogRoles'
import NewCatalogRoles from './NewCatalogRoles'

const AdminCatalogRolesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogRoles /></PrivateRoute7>} />
        <Route path="edit-catalog-role" element={<PrivateRoute7><EditCatalogRoles /></PrivateRoute7>} />
        <Route path="new-catalog-role" element={<PrivateRoute7><NewCatalogRoles /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogRolesRoutes